import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { CommonService } from "src/app/Service/Common.service";
import { IProjectElementDetailsOutput, IProjectElementsOutput } from "src/app/ViewModel/ProjectElementsModel";
import { FieldConfig } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { Module } from "src/app/Service/element-details.data.service";
import { BehaviorSubject, Subscription } from "rxjs";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ScheduleDocumentService } from 'src/app/Service/scheduledocument/scheduleDocument.service';
import { WorkflowTemplateModel } from 'src/app/ViewModel/WorkflowTemplateModel';
import { BusinessGroupModel } from "src/app/ViewModel/BusinessGroupModel";
import { NotificationService } from "src/app/Service/notification.service";

@Component({
  selector: 'app-standard-drawing-link',
  templateUrl: './standard-drawing-link.component.html',
  styleUrls: ['./standard-drawing-link.component.css']
})
export class StandardDrawingLinkComponent implements OnInit {

  @ViewChild("docSetForm") dynamicForm: DynamicFormComponent;
  projectId!: number;
  groupId!: number;
  memberId!: number;
  projectStaticElements: IProjectElementsOutput[] = [];
  projectElements: IProjectElementsOutput[];
  searchTypeList: any = [];
  public regConfig: FieldConfig[] = [];
  UnsubscribeArray: Subscription[] = [];
  schSeachFieldsConfig: FieldConfig[] = [];
  elementsConfig: FieldConfig[] = [];
  numElements: Map<string, string> = new Map<string, string>();
  workflowList: WorkflowTemplateModel[] = [];
  selectedWorkflownumber: number = 0;
  selectedgroup_Id: number = 0;
  selectedReleaseId: number = 0;
  eleValue: IProjectElementDetailsOutput[] = [];
  projBusinessGroups: BusinessGroupModel[] = [];
  dciStatusList: IProjectElementDetailsOutput[] = [];

  @ViewChild('schSearchForm') schSearchDynamicForm!: DynamicFormComponent;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,public _dialogRef: MatDialogRef<StandardDrawingLinkComponent>, 
    private _commonService: CommonService, private _projInfoService: ProjectInfoService, private _scheduleDocService: ScheduleDocumentService,
     private _notificationService: NotificationService,)
  { }

  ngOnInit(): void {
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.projectId = this._commonService.getProjectId();
    this.getDynamicForm();
    this.getWorkflowDetails();
    this.getProjectBusinessGroups();
    this.getElementDetails("Status", Module.ScheduleDocument);

  }

  closeDialog() {
    this._dialogRef.close();
  }

  getDynamicForm() {
    let GetprojectElements = this._projInfoService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: false }).subscribe(
        (res: IProjectElementsOutput[]) => {
            this.projectElements = res;
            this.projectElements.forEach(element => {
                if (element.elementDescription != 'Project Code') {
                    this.searchTypeList.push({ value: element.elementId, description: element.elementDescription });
                }
            });
            this.regConfig = res.map(x => {
                let field: FieldConfig;
                let childDEId = null;
                let childDEDescription = "";
                let data = res.filter(item => item.dependentElementId == x.elementId);
                if (data.length > 0) {
                    childDEId = data[0].elementId;
                    childDEDescription = data[0].elementDescription;
                }
                field = {
                    de_id: x.elementId,
                    module_id: Module.ScheduleDocument,
                    dependent_de_id: x.dependentElementId,
                    dependent_de_Description: x.dependentElementDescription,
                    child_de_id: childDEId,
                    child_de_Description: childDEDescription,
                    name: x.elementDescription,
                    deDescription: x.elementDescription,
                    type: 'select'
                }
                return field;
            });
            this.dynamicForm.fields = this.regConfig;
            this.dynamicForm.createControl();
        });
    this.UnsubscribeArray.push(GetprojectElements);
}

getProjectBusinessGroups() {
  let _getProjectBusinessGroups = this._commonService.getProjectBusinessGroups(this._commonService.getProjectId()).subscribe(res => 
    {
      this.projBusinessGroups = res.filter(x => x.is_Active);
    });
  this.UnsubscribeArray.push(_getProjectBusinessGroups);

}

public getElementDetails(elementName: string, moduleId?: number) 
{
  if (!moduleId)
      moduleId = Module.ScheduleDocument
  let _getProjectElementDetails = this._projInfoService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: moduleId, deDescription: elementName })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
          switch (elementName) {
              case "Status":
                  this.dciStatusList = res;
                  break;
          }
      }, err => { });
  this.UnsubscribeArray.push(_getProjectElementDetails);
}


createSearchFieldsForm() {
  this.schSeachFieldsConfig = this.getSchSearchConfig();
  this.schSearchDynamicForm.fields = this.schSeachFieldsConfig;
  this.schSearchDynamicForm.createControl();
}
getSchSearchConfig(): FieldConfig[] {
  return [
      {
          type: 'eipdatepicker',
          name: 'fromDate',
          label: 'From'
      },
      {
          type: 'eipdatepicker',
          name: 'toDate',
          label: 'To'
      }];
}

getWorkflowDetails() {
  let getWfDetails = this._scheduleDocService.GetWorkflowList().subscribe((x: WorkflowTemplateModel[]) => {
    this.workflowList = x;
    this.workflowList = this.workflowList.filter(x => x.scheduleType == 3);
  });
  this.UnsubscribeArray.push(getWfDetails);
}

selectedworkflowvalue(event: any) {
  this.selectedWorkflownumber = event.additionalValues.additionalValues.workflowId;
}

selectedApprovalby(event: any)
{
  this.selectedgroup_Id = event.additionalValues.additionalValues.group_Id;
}

selectedReleasedfor(event: any)
{
  this.selectedReleaseId = event.additionalValues.additionalValues.dedId;
}

closeworkflowTab(event: any) {
  this.selectedWorkflownumber = 0;
}
postElementdetails() 
{
  if(this.dynamicForm.form.valid && this.selectedWorkflownumber!=0 && this.selectedgroup_Id!=0 && this.selectedReleaseId!=0)
  {      
    let resForm: FormGroup | undefined | null = this.dynamicForm.form;
    let elementInp: IProjectElementDetailsOutput[] = this.projectElements.map(x => 
    {
      let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription).value;
      if (selectedValue == null) {
          return null;
      } else {
          let result: IProjectElementDetailsOutput = {
              deId: x.elementId,
              dedId: selectedValue.dedId,
              deDescription: x.elementDescription,
              dedDescription: selectedValue.dedDescription,
              dedShortDescription: selectedValue.dedShortDescription,
              sortBy: +selectedValue.sortBy
          };
          return result;
      }
    }).filter(x => x !== null) as IProjectElementDetailsOutput[];
    this.eleValue = elementInp;

    // Return the selected Impact details
    let obj: any = {};
    obj["eleValue"] = this.eleValue;
    obj["selectedWorkflownumber"] = this.selectedWorkflownumber;
    obj["selectedgroup_Id"] = this.selectedgroup_Id;
    obj["selectedReleaseId"] = this.selectedReleaseId;
    this._dialogRef.close(obj);
  }
  else
  {
    this._notificationService.showToast("Fill all the fields", "Warning");
  }
}

}
